// 公用js，建议使用IIFE（立即执行函数）
(function () {
  if ($('.last-page').length > 0) {
    var lastHref = $('.last-page').attr('href');
    var tempHref1 = lastHref.split('-')[0];
    var tempHref2 = lastHref.split('-')[1];
    var lastPageNum = parseInt(tempHref2.split('.')[0]);
    $('.yn-pagination .last-page').after(
      '<span class="page-num total-page-num" >共' +
        lastPageNum +
        '页</span><span class="page-num go-page"  style="cursor: pointer;">转到</span><span class="page-num" style="padding-left:5px;padding-right:5px;"><input name="pageinput" type="text" class="page-input" style="border:none; width:50px;  outline: none; text-align:center;"></span>'
    );
    $('.yn-pagination .go-page').on('click', function () {
      var pageNum = parseInt($('.page-input').val());

      if (pageNum === '') {
        alert('请输入页码！');
        return false;
      }
      if (isNaN(pageNum) || pageNum <= 0 || pageNum > lastPageNum) {
        alert('请输入正确页码！');
        return false;
      }
      toHref = tempHref1 + '-' + pageNum + '.html';
      window.location.href = toHref;
    });
  }
  // 图片集
  $('.J_content').slick({
    dots: true,
    dotsClass: 'custom_paging',
    customPaging: function (slider, i) {
        return `<b class='active-index'>`+ (i + 1) +`</b>`+ `<span class="separator">`+'/'+`</span>` + `<em class='slide-count'>`+ slider.slideCount +`</em>`;
    }
  })
})();

//# sourceMappingURL=module.js.map
